import { ComponentType } from '@angular/cdk/portal';
import { Component, InputSignal, inject, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { EMPTY, Observable } from 'rxjs';

import { ComponentFlyoutService } from '../flyout/component/component-flyout.service';
import { FlyoutComponent } from '../flyout/component/flyout-component';
import { CustomOverlayConfig } from '../flyout/custom-overlay/custom-overlay-config';

@Component({
  selector: 'mp-component-flyout-test',
  template: '<button mat-raised-button (click)="showFlyout()">Open Flyout</button>',
  imports: [MatButton],
})
export class ComponentFlyoutTestComponent<
  T extends FlyoutComponent<unknown> = FlyoutComponent<unknown>,
  PayloadType = unknown,
> {
  private readonly componentFlyoutService: ComponentFlyoutService = inject(ComponentFlyoutService);

  readonly componentType: InputSignal<ComponentType<T>> = input.required<ComponentType<T>>();
  readonly flyoutConfig: InputSignal<CustomOverlayConfig<PayloadType>> = input<CustomOverlayConfig<PayloadType>>(
    {} as CustomOverlayConfig<PayloadType>,
  );

  showFlyout(): Observable<unknown> {
    if (this.componentFlyoutService.isCurrentlyOpened()) {
      return EMPTY;
    }

    return this.componentFlyoutService.open(this.componentType(), this.flyoutConfig()).afterClosed$;
  }
}
